import paths from 'routing/routes/_paths';

import auth from 'assets/svg/navbar/auth.svg';
import companies from 'assets/svg/navbar/companies.svg';
import enums from 'assets/svg/navbar/enums.svg';
import indexes from 'assets/svg/navbar/indexes.svg';
import integrations from 'assets/svg/navbar/integrations.svg';
import routes from 'assets/svg/navbar/routes.svg';
import users from 'assets/svg/navbar/users.svg';
import reports from 'assets/svg/navbar/reports.svg';
import beacon from 'common/assets/svg/common/beacon.svg';
import aiSpark from 'common/assets/svg/common/ai-spark.svg';
import setup from 'common/assets/svg/common/setup.svg';

export const items = [
  {
    path: paths.companies,
    icon: companies,
    name: 'Companies',
    label: 'companies'
  },
  {
    icon: enums,
    name: 'Enums',
    label: 'enums',
    hiddenSubmenu: true,
    path: paths.enums.cargo,
    submenu: [
      {
        path: paths.enums.cargo,
        name: 'Cargo Grades',
        label: 'cargo'
      },
      {
        path: paths.enums.classification_societies,
        name: 'Classification societies',
        label: 'Classification societies'
      },
      {
        path: paths.enums.cp_forms,
        name: 'CP Forms',
        label: 'CP Forms'
      },
      {
        path: paths.enums.fuel_grades,
        name: 'Fuel Grades',
        label: 'Fuel Grades'
      },
      {
        path: paths.enums.ports,
        name: 'Ports',
        label: 'ports'
      },
      {
        path: paths.enums.routing_areas,
        name: 'Routing Areas',
        label: 'Routing Areas'
      },
      // {
      //   path: paths.enums.vessels,
      //   name: 'Vessels',
      //   label: 'vessels'
      // },
      { path: paths.enums.vessel_prefixes, name: 'Vessel Prefixes', label: 'Vessel Prefixes' },
      {
        path: paths.enums.vessel_situations,
        name: 'Vessel Situations',
        label: 'Vessel Situations'
      },
      {
        path: paths.enums.widget_types,
        name: 'Widget Types',
        label: 'Widget Types'
      }
    ]
  },
  {
    path: paths.indexes,
    icon: indexes,
    name: 'Indexes',
    label: 'indexes'
  },
  {
    icon: integrations,
    name: 'Integrations',
    label: 'integrations',
    path: `${paths.integrations}/logs`
  },
  {
    path: paths.users,
    icon: users,
    name: 'Orca Users',
    label: 'users'
  },
  {
    path: paths.reports,
    icon: reports,
    name: 'Reports',
    label: 'reports'
  },
  {
    icon: routes,
    name: 'Routes',
    label: 'routes',
    path: paths.routes
  },
  {
    icon: beacon,
    name: 'Beacon',
    label: 'beacon',
    path: paths.beacon
  },
  {
    path: paths.authorization,
    icon: auth,
    name: 'Authorization',
    label: 'authorization'
  },
  {
    icon: aiSpark,
    name: 'AI Logs',
    label: 'ai_logs',
    path: paths.ai_logs
  },
  {
    icon: setup,
    name: 'Company Settings',
    label: 'company_settings',
    path: paths.company_settings
  }
];
